import { round } from 'lodash';
import React from 'react';
import { checkArray, checkIs3DigitDecimal, check4DigitDecimal } from '../../../../Components/helper';
import { isValidGradingInput, GRADING_INPUT_PATTERN, validateIntermediateGradingInput, checkIs3DigitDecimalSigned } from '../../../../utils/calculationHelpers';
import noImage from '../../../../assets/images/no-image.png';

function POMTable({
  specTemplateData,
  specTempGradingLib,
  handlePOMInput,
  calculateMeasurement,
  isPageDisable,
  handleTolIinput,
  t,
  deleteSinglePOM,
  onSelectCheckBox,
  SpecDeleteAccess,
  selectedIdArray,
  handleCheckALl,
}) {
  function isNumberOrSpecial(val, hasIsSampleKey, shouldRound, hasIsZeroKey = false) {
    if (val === undefined || val === null || val === '') return '';
    if ((hasIsZeroKey || hasIsSampleKey) && val !== '' && Number.isNaN(Number(val))) return 0;

    const isString = typeof val === 'string';
    const parsed = isString ? Number(val) : val;
    const isNumeric = typeof parsed === 'number' && Number.isFinite(parsed);

    // Preserve string for grading or incomplete decimal entry
    const isPartialDecimal = /^[+-]?(\d+\.?\d*|\.\d+)$/.test(val) || val === '.' || val === '+' || val === '-';
    if (isString && (!shouldRound || isPartialDecimal)) return val;

    // Round for measurement fields
    if (isNumeric && shouldRound && !hasIsZeroKey && !hasIsSampleKey) return round(parsed, 3);

    return isNumeric ? parsed : val;
  }
  const forImage = (item) => {
    if (item?.annotatedImage && item?.annotatedImage !== '') {
      return item.annotatedImage;
    }
    return item?.image || noImage;
  };
  return (
    <div className="table-responsive">
      <table className="table common-custom-table layout-fixed spec-pom-table">
        <thead>
          <tr>
            <th className="w-50px">
              <div className="checkbox-label no-label margin-auto">
                <input
                  onChange={(e) => {
                    handleCheckALl(e);
                  }}
                  name="check_all_pom"
                  id="check_all_pom"
                  type="checkbox"
                  disabled={isPageDisable}
                  checked={selectedIdArray?.length > 0 && selectedIdArray?.length === specTemplateData?.pomLibraries?.length}
                />

                <label htmlFor="check_all_pom" className="chklabel">
                  <span />
                </label>
              </div>
            </th>
            <th className="w-100px">{t('SPEC_TEMP_LIBRARY.IMAGE')}</th>
            <th className="w-120px">{t('SPEC_TEMP_LIBRARY.POM_CODE')}</th>
            <th className="w-300px">{t('SPEC_TEMP_LIBRARY.POM_DESC')}</th>
            {specTempGradingLib?.sizeRanges?.map((eleSize) => {
              return (
                <th key={eleSize} className="w-100px">
                  {eleSize?.name}
                </th>
              );
            })}
            <th className="w-100px">{t('SPEC_TEMP_LIBRARY.TOL')}</th>
            <th className="w-80px">{t('SPEC_TEMP_LIBRARY.ACTION')}</th>
          </tr>
        </thead>
        <tbody>
          {checkArray(specTemplateData?.pomLibraries) ? (
            specTemplateData?.pomLibraries?.map((specPom, iPomIndex) => {
              return (
                <tr key={specPom?.code}>
                  <td>
                    <div className="checkbox-label no-label margin-auto">
                      <input
                        disabled={isPageDisable}
                        onChange={() => {
                          onSelectCheckBox(specPom?.code);
                        }}
                        name={`checks_${specPom?.code}`}
                        id={`checks_${specPom?.code}`}
                        type="checkbox"
                        checked={selectedIdArray.filter((val) => val === specPom?.code).length > 0}
                      />
                      <label htmlFor={`checks_${specPom?.code}`} className="chklabel">
                        <span />
                      </label>
                    </div>
                  </td>
                  <td>
                    <img width="80" src={forImage(specPom)} alt="Pom Img" />
                  </td>
                  <td>{specPom?.code}</td>
                  <td>{specPom?.description}</td>
                  {specTempGradingLib?.sizeRanges?.map((eleSize, iSize) => {
                    const matchingGrad = specPom?.gradings?.find((grad) => grad?.sizeName === eleSize?.name);
                    // Authoritative sample-size flag comes from the size-range object; grading entry is the fallback
                    const isSampleSize = eleSize?.isSampleSize ?? (matchingGrad?.isZero || matchingGrad?.isSampleSize);
                    return (
                      <td key={`${eleSize}_${iSize}`}>
                        <div className="w-100 text-center">
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            disabled={!isSampleSize || isPageDisable}
                            onKeyPress={(e) => {
                              const allowed = GRADING_INPUT_PATTERN;
                              if (!allowed.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            value={matchingGrad ? isNumberOrSpecial(matchingGrad?.measurment, matchingGrad?.isSampleSize, true, matchingGrad?.isZero) : 0}
                            className="form-control input-spec-text text-bordered text-center mb-1"
                            onBlur={() => calculateMeasurement(iPomIndex)}
                            defaultValue={0}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (checkIs3DigitDecimal(val) && check4DigitDecimal(val)) {
                                handlePOMInput(val, 'measurment', eleSize.name, iPomIndex);
                              }
                            }}
                          />
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            disabled={isSampleSize || isPageDisable}
                            onKeyPress={(e) => {
                              const allowed = GRADING_INPUT_PATTERN;
                              if (!allowed.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            value={matchingGrad ? isNumberOrSpecial(matchingGrad?.grading, matchingGrad?.isSampleSize, false, matchingGrad?.isZero) : 0}
                            onBlur={() => calculateMeasurement(iPomIndex)}
                            className="form-control input-spec-text text-bordered text-center"
                            onChange={(e) => {
                              const val = e.target.value;
                              if (validateIntermediateGradingInput(val) && (val === '' || (isValidGradingInput(val) && checkIs3DigitDecimalSigned(val)))) {
                                handlePOMInput(val, 'grading', eleSize.name, iPomIndex);
                              }
                            }}
                          />
                        </div>
                      </td>
                    );
                  })}
                  <td>
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-control text-bordered text-center"
                      disabled={isPageDisable}
                      onChange={(e) => handleTolIinput(e.target.value, 'tolMinus', iPomIndex)}
                      value={specPom?.tolMinus && round(specPom.tolMinus, 3)}
                    />
                  </td>
                  <td>
                    {SpecDeleteAccess && (
                      <button className="btn" aria-label="Delete" disabled={isPageDisable} type="submit" onClick={() => deleteSinglePOM(specPom?.code)}>
                        <i className="icon-Delete" title="Delete" />
                      </button>
                    )}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td className="text-center" colSpan={6 + (specTemplateData?.selectedGradingLib?.sizeRanges?.length || 0)}>
                {t('SPEC_TEMP_LIBRARY.NO_POM_FOUND')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default POMTable;
